import { render, staticRenderFns } from "./CustomTable.vue?vue&type=template&id=0a304629"
import script from "./CustomTable.vue?vue&type=script&lang=ts"
export * from "./CustomTable.vue?vue&type=script&lang=ts"
import style0 from "./CustomTable.vue?vue&type=style&index=0&id=0a304629&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a304629')) {
      api.createRecord('0a304629', component.options)
    } else {
      api.reload('0a304629', component.options)
    }
    module.hot.accept("./CustomTable.vue?vue&type=template&id=0a304629", function () {
      api.rerender('0a304629', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CustomTable.vue"
export default component.exports